import { useContext } from 'react';
import { CascaderContext } from '../context/cascader';
export function useCascader() {
  var cascader = useContext(CascaderContext);

  if (cascader == null) {
    throw new Error('useCascader must be use under RcCascader');
  }

  return cascader;
}